import React from 'react';

const NotFound = () => {
  return (
    <div className='nothing'>
      <h1>
        404 <small>Not Found :(</small>
      </h1>
    </div>
  );
};

export default NotFound;